import { NgModule } from '@angular/core';
import { CoreModule } from './core.Module';
//import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { TextAreaModule } from '../components/text-area/modules/textarea.module';
import { TextBoxModule } from '../components/text-box/modules/textbox.module';
import { ModalModule } from '../components/modal/modules/modal.module';
import { DatePickerModule } from '../components/date-picker/modules/datpicker.module';
import { VerificationCodeModule } from '../components/verification-code/modules/verificationcode.module';
import { RecaptchaModule } from '../components/recaptcha/recaptcha.module';
import { SelectDropDownModule } from 'ngx-select-dropdown';
import { NgbTabsetModule, NgbTooltip, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms';
import { ClickOutsideModule } from 'ng-click-outside';
import { PasswordTextBoxModule } from '../components/password-textbox/modules/password-textbox.module';

import { CounterModule } from '../components/counter/modules/counter.module';
import { BtnToggleModule } from '../components/btn-toggle/modules/btntoggle.module';
import { TimePickerComponent } from '../components/time-picker/components/time-picker.component';
import { TimePickerModule } from '../components/time-picker/modules/time-picker.module';
import { GregorianDatePickerModule } from '../components/gregorian-date-picker/modules/gregorian-date-picker.module';
import { FileUploadModule } from '../components/file-upload/modules/file-upload.module';
import { ProgressBarModule } from '../components/progress-bar/modules/progressbar.module';
import { TimeControlModule } from '../components/time-control/modules/time-control.module';
import { CustomSelectDropDownModule } from '../components/ngx-dropdown/ngx-select-dropdown.module';
import { ClipboardModule } from 'ngx-clipboard';
//import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AdahiAccordionModule } from '../components/accordion/modules/accordion.module';
import { SpreadsheetGridModule } from '../components/spreadsheet-grid/modules/spreadsheet-grid.module';
import { ColorPickerComponentModule } from '../components/color-picker/modules/color-picker.module';
import { RichHtmlModule } from '../components/rich-html/modules/richhtml.module';
import { PeoplePickerComponentModule } from '../components/people-picker/modules/people-picker.module';


@NgModule({
    imports: [
        //BrowserModule,
        CoreModule,
        CommonModule,
        FormsModule,
        //SelectDropDownModule,
        ModalModule,
        DatePickerModule,
        GregorianDatePickerModule,
        TextAreaModule,
        VerificationCodeModule,
        NgbTabsetModule,
        ClickOutsideModule,
        PasswordTextBoxModule,
        CounterModule,
        BtnToggleModule,
        NgbTooltipModule,
        TimePickerModule,
        FileUploadModule,
        ProgressBarModule,
        TimeControlModule,
        ClipboardModule,
        //BrowserAnimationsModule,
        AdahiAccordionModule,
        SpreadsheetGridModule,
        ColorPickerComponentModule,
        RichHtmlModule,
        PeoplePickerComponentModule

    ],
    exports: [
        //BrowserModule,
        CoreModule,
        CommonModule,
        FormsModule,
        TextBoxModule,
        PasswordTextBoxModule,
        RecaptchaModule,
        //SelectDropDownModule,
        ModalModule,
        DatePickerModule,
        GregorianDatePickerModule,
        TextAreaModule,
        VerificationCodeModule,
        NgbTabsetModule,
        ClickOutsideModule,
        CounterModule,
        BtnToggleModule,
        NgbTooltipModule,
        TimePickerModule,
        FileUploadModule,
        ProgressBarModule,
        TimeControlModule,
        CustomSelectDropDownModule,
        ClipboardModule,
        //BrowserAnimationsModule,
        AdahiAccordionModule,
        SpreadsheetGridModule,
        ColorPickerComponentModule,
        RichHtmlModule,
        PeoplePickerComponentModule

    ],
    declarations: [
    ],
    providers: [
    ]
})
export class FormModule {

}
